"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProtectedRoute = void 0;
var react_1 = __importStar(require("react"));
var react_router_1 = require("react-router");
var react_redux_1 = require("react-redux");
var LoadingIndicator_1 = require("../LoadingIndicator");
var ProtectedRoute = /** @class */ (function (_super) {
    __extends(ProtectedRoute, _super);
    function ProtectedRoute() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProtectedRoute.prototype.render = function () {
        if (!this.props.authCheckComplete) {
            return react_1.default.createElement(LoadingIndicator_1.LoadingIndicator, null);
        }
        var redirectPath = this.props.location ? this.props.location.pathname : undefined;
        return (!this.props.isAuthenticated || !this.props.termsOfServiceAccepted) && !this.props.isLogoutInitiated ?
            react_1.default.createElement(react_router_1.Redirect, { to: { pathname: '/login', search: redirectPath ? "?redirectTo=" + redirectPath : undefined } }) :
            react_1.default.createElement(react_router_1.Route, __assign({}, this.props));
    };
    return ProtectedRoute;
}(react_1.Component));
exports.ProtectedRoute = ProtectedRoute;
var mapStateToProps = function (state) {
    return {
        isAuthenticated: state.auth.isAuthenticated,
        termsOfServiceAccepted: state.auth.termsOfServiceAccepted,
        isLogoutInitiated: state.auth.isLogoutInitiated,
        authCheckComplete: state.auth.authCheckComplete
    };
};
exports.default = react_redux_1.connect(mapStateToProps)(ProtectedRoute);
